<div class="iframe-container">
	<iframe [src]="url" class="iframe-content"></iframe>
</div>
